import type { Leasing } from '../../../../../types'

export function leasingReportColumns() {
  const exportColumns: { key: keyof Leasing; header: string; width: number }[] = [
    { key: 'accountNo', header: 'Kontonr', width: 15 },
    { key: 'regNo', header: 'Regnr', width: 15 },
    { key: 'vehicleID', header: 'Kjøretøy Id', width: 15 },
    { key: 'consolidatedAgreementID', header: 'Samleavtale ID', width: 20 },
    { key: 'consolidatedAgreement', header: 'Samleavtale', width: 30 },
    { key: 'driverName', header: 'Sjåfør', width: 25 },
    { key: 'maxKm', header: 'Maks km', width: 15 },
    { key: 'totalTerms', header: 'Terminer totalt', width: 10 },
    { key: 'termsNow', header: 'Terminer løpt', width: 15 },
    { key: 'remainingTerms', header: 'Terminer gjenstår', width: 20 },
    { key: 'startDate', header: 'Startdato', width: 15 },
    { key: 'returnDate', header: 'Returdato', width: 15 },
    { key: 'termLeasingInclVAT', header: 'Leasingleie mnd inkl. mva', width: 20 },
    { key: 'restLeasingInclVAT', header: 'Leasing forpliktelser ink. mva', width: 25 },
    { key: 'restLeasingExclVAT', header: 'Leasing forpliktelser eks. mva', width: 25 },
  ]

  return exportColumns
}
